"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxGroup = void 0;

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _core = require("@chakra-ui/core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var CheckboxGroup = function CheckboxGroup(props) {
  var _props$label, _props$options, _props$help;

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (props === null || props === void 0 ? void 0 : (_props$label = props.label) === null || _props$label === void 0 ? void 0 : _props$label.length) > 0 && /*#__PURE__*/_react["default"].createElement(_core.Text, {
    mb: "8px"
  }, props.label, props.required && /*#__PURE__*/_react["default"].createElement(_core.Text, {
    as: "sup",
    color: "brand.red"
  }, "*")), (props === null || props === void 0 ? void 0 : (_props$options = props.options) === null || _props$options === void 0 ? void 0 : _props$options.length) > 0 && /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: props.name
  }, function (_ref) {
    var field = _ref.field,
        form = _ref.form;
    return /*#__PURE__*/_react["default"].createElement(_formik.FieldArray, {
      name: field.name
    }, function (_ref2) {
      var push = _ref2.push,
          remove = _ref2.remove;
      return /*#__PURE__*/_react["default"].createElement(_core.Stack, null, props.options.map(function (option, idx) {
        var _option$label;

        return /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
          id: option.value,
          key: "".concat(field.name, "-").concat(idx),
          mb: '5px',
          "aria-label": option.label,
          size: "md",
          color: "brand.blue",
          borderColor: "gray.500",
          checked: field.value.includes(option.value),
          "data-value": option.value,
          isDisabled: form.isSubmitting || props.disabled,
          onChange: function onChange(e) {
            var target = e.currentTarget;

            if (target.checked) {
              push(option.value);
            } else {
              var optionIdx = field.value.indexOf(option.value);
              remove(optionIdx, 1);
            }
          }
        }, (option === null || option === void 0 ? void 0 : (_option$label = option.label) === null || _option$label === void 0 ? void 0 : _option$label.length) > 0 && /*#__PURE__*/_react["default"].createElement(_core.Text, {
          fontSize: "14px",
          my: "0"
        }, option.label));
      }));
    });
  }), (props === null || props === void 0 ? void 0 : (_props$help = props.help) === null || _props$help === void 0 ? void 0 : _props$help.length) > 0 && /*#__PURE__*/_react["default"].createElement(_core.Text, {
    color: "gray.500",
    fontSize: "sm",
    mb: {
      base: "15px",
      md: "30px"
    }
  }, props.help));
};

exports.CheckboxGroup = CheckboxGroup;